import { useState } from "react";

import { PriorityRequestFilters } from "../PriorityRequests.types";
import { DEFAULT_PRIORITY_REQUEST_FILTERS, priorityRequestFiltersKey } from "../PriorityRequests.utils";
import { usePriorityRequestsQuery } from "./usePriorityRequestsQuery";

export function usePriorityRequests() {
  const [filters, setFilters] = useState<PriorityRequestFilters>(DEFAULT_PRIORITY_REQUEST_FILTERS);
  const { data, isLoading, isPlaceholderData, isError } = usePriorityRequestsQuery(filters);

  const rows = data ?? [];

  return {
    filters,
    changeFilters: (changes: Partial<PriorityRequestFilters>) => setFilters((current) => ({ ...current, ...changes })),
    rows,
    isLoading: isLoading || isPlaceholderData,
    isError,
    isEmpty: !isLoading && !isError && rows.length === 0,
    paginationResetKey: priorityRequestFiltersKey(filters),
  };
}
